export default __webpack_public_path__ + "static/media/702.72cb3916.png";